function floorPlanInteractiveExperience() {
	const blocks = document.querySelectorAll(
		".floor-plan-interactive-experience",
	);

	blocks.forEach((block) => {
		const floorSelector = block.querySelector("[data-floor-selector]");
		const floorSelectorLabel = block.querySelector(
			"[data-floor-selector-label]",
		);
		const roomSelectorLabel = block.querySelector(
			"[data-room-selector-label]",
		);
		const residenceContent = block.querySelector(
			"[data-residence-content]",
		);
		const floorPlansWrapper = block.querySelector("[data-floor-plans]");
		const viewSelectedButton = block.querySelector(
			"[data-residence-view-selected]",
		);
		const backButton = block.querySelector("[data-residence-back]");
		const floorPlans = Array.from(
			block.querySelectorAll("[data-floor-plan]"),
		);
		const roomLabels = Array.from(
			block.querySelectorAll("[data-floor-plan] text[data-room-id]"),
		);
		const detailsPanels = Array.from(
			block.querySelectorAll("[data-residence-details]"),
		);
		const rooms = Array.from(block.querySelectorAll('[id^="room-"]')).filter(
			(room) => {
				const floorPlan = room.closest("[data-floor-plan]");
				const floorGroup = floorPlan
					? floorPlan.getAttribute("data-floor-plan")
					: "";
				const isAvailable = detailsPanels.some(
					(panel) =>
						panel.getAttribute("data-floor-group") === floorGroup &&
						panel.getAttribute("data-room-id") === room.id,
				);

				room.classList.toggle("is-disabled", !isAvailable);
				room.setAttribute("aria-disabled", isAvailable ? "false" : "true");

				return isAvailable;
			},
		);
		const imagePanels = Array.from(
			block.querySelectorAll("[data-residence-image]"),
		);
		const selectorFloors = floorSelector
			? Array.from(floorSelector.querySelectorAll("[data-floor-group]"))
			: [];
		const availableFloorGroups = floorPlans
			.map((floorPlan) => floorPlan.getAttribute("data-floor-plan"))
			.filter(Boolean);
		const floors = selectorFloors.filter((floor) => {
			const isAvailable = availableFloorGroups.includes(
				floor.getAttribute("data-floor-group"),
			);

			floor.classList.toggle("is-disabled", !isAvailable);
			floor.setAttribute("aria-disabled", isAvailable ? "false" : "true");

			return isAvailable;
		});

		if (!floorSelector || !floorSelectorLabel || !floors.length) {
			return;
		}

		let hasSetInitialResidence = false;
		let changeTimer;
		let stepTimer;

		const getFloorPlanKey = (element) => {
			if (!element) {
				return "";
			}

			return element.getAttribute("data-floor-plan");
		};

		const getRoomLabels = (room) => {
			const floorPlan = room.closest("[data-floor-plan]");

			return roomLabels.filter((text) => {
				if (text.closest("[data-floor-plan]") !== floorPlan) {
					return false;
				}

				return text.getAttribute("data-room-id") === room.id;
			});
		};

		const panelMatchesResidence = (panel, floorGroup, roomId) =>
			panel.getAttribute("data-floor-group") === floorGroup &&
			panel.getAttribute("data-room-id") === roomId;

		const showMatchingPanels = (panels, isActive) => {
			panels.forEach((panel) => {
				const active = isActive(panel);

				panel.hidden = !active;
				panel.classList.toggle("is-active", active);
			});
		};

		const updateActiveResidence = (floorGroup, roomId) => {
			floors.forEach((item) => {
				item.classList.toggle(
					"is-active",
					item.getAttribute("data-floor-group") === floorGroup,
				);
			});

			showMatchingPanels(
				floorPlans,
				(floorPlan) =>
					getFloorPlanKey(floorPlan) === floorGroup,
			);

			rooms.forEach((room) => {
				const floorPlan = room.closest("[data-floor-plan]");
				const isActive =
					getFloorPlanKey(floorPlan) === floorGroup && room.id === roomId;

				room.classList.toggle("is-active", isActive);
			});

			roomLabels.forEach((roomLabel) => {
				roomLabel.classList.remove("is-active");
			});

			const activeRoom = rooms.find((room) => {
				const floorPlan = room.closest("[data-floor-plan]");

				return (
					getFloorPlanKey(floorPlan) === floorGroup &&
					room.id === roomId
				);
			});

			if (activeRoom) {
				getRoomLabels(activeRoom).forEach((roomLabel) => {
					roomLabel.classList.add("is-active");
				});
			}

			showMatchingPanels(
				detailsPanels,
				(panel) => panelMatchesResidence(panel, floorGroup, roomId),
			);

			showMatchingPanels(
				imagePanels,
				(panel) => panelMatchesResidence(panel, floorGroup, roomId),
			);

			const activeFloorPlan = floorPlans.find(
				(floorPlan) => getFloorPlanKey(floorPlan) === floorGroup,
			);

			if (activeFloorPlan) {
				floorSelectorLabel.textContent =
					activeFloorPlan.getAttribute("data-floor-label");
			}

			if (roomSelectorLabel) {
				roomSelectorLabel.textContent = `Residence ${roomId.replace("room-", "")}`;
			}
		};

		const setTransitionState = (isChanging, includeRoomSelector) => {
			residenceContent.classList.toggle("is-changing", isChanging);

			if (floorPlansWrapper) {
				if (includeRoomSelector) {
					floorPlansWrapper.classList.toggle("is-changing", isChanging);
				} else {
					floorPlansWrapper.classList.remove("is-changing");
				}
			}
		};

		const scrollToBlockTop = () => {
			const blockTop =
				block.getBoundingClientRect().top + window.pageYOffset;

			if (window.pageYOffset > blockTop) {
				window.scrollTo({
					top: blockTop,
					behavior: "smooth",
				});
			}
		};

		const setMobileStep = (showDetails) => {
			window.clearTimeout(stepTimer);
			block.classList.add("is-step-changing");
			scrollToBlockTop();

			stepTimer = window.setTimeout(() => {
				block.classList.toggle("is-viewing-details", showDetails);

				window.requestAnimationFrame(() => {
					block.classList.remove("is-step-changing");
				});
			}, 180);
		};

		const showMobileDetails = () => {
			setMobileStep(true);
		};

		const showMobileSelection = () => {
			setMobileStep(false);
		};

		const setActiveResidence = (floorGroup, roomId, fadeRoomSelector) => {
			const activePanel = detailsPanels.find(
				(panel) => panelMatchesResidence(panel, floorGroup, roomId),
			);

			if (!activePanel) {
				return;
			}

			if (!activePanel.hidden && hasSetInitialResidence) {
				return;
			}

			if (!residenceContent || !hasSetInitialResidence) {
				updateActiveResidence(floorGroup, roomId);
				hasSetInitialResidence = true;
				return;
			}

			window.clearTimeout(changeTimer);
			setTransitionState(true, fadeRoomSelector);

			if (window.matchMedia("(min-width: 64em)").matches) {
				scrollToBlockTop();
			}

			changeTimer = window.setTimeout(() => {
				updateActiveResidence(floorGroup, roomId);

				window.requestAnimationFrame(() => {
					setTransitionState(false, fadeRoomSelector);
				});
			}, 180);
		};

		const setActiveFloor = (floor) => {
			const floorGroup = floor.getAttribute("data-floor-group");
			const firstResidence = detailsPanels.find(
				(panel) =>
					panel.getAttribute("data-floor-group") === floorGroup,
			);
			const roomId = firstResidence
				? firstResidence.getAttribute("data-room-id")
				: "";

			setActiveResidence(floorGroup, roomId, true);
		};

		floors.forEach((floor) => {
			floor.addEventListener("click", () => {
				setActiveFloor(floor);
			});
		});

		if (viewSelectedButton) {
			viewSelectedButton.addEventListener("click", showMobileDetails);
		}

		if (backButton) {
			backButton.addEventListener("click", showMobileSelection);
		}

		rooms.forEach((room) => {
			room.addEventListener("mouseenter", () => {
				getRoomLabels(room).forEach((roomLabel) => {
					roomLabel.classList.add("is-hovered");
				});
			});

			room.addEventListener("mouseleave", () => {
				getRoomLabels(room).forEach((roomLabel) => {
					roomLabel.classList.remove("is-hovered");
				});
			});

			room.addEventListener("click", () => {
				const floorPlan = room.closest("[data-floor-plan]");
				const floorGroup = getFloorPlanKey(floorPlan);

				if (!floorGroup) {
					return;
				}

				setActiveResidence(floorGroup, room.id);
			});
		});

		const defaultFloorKey =
			block.getAttribute("data-default-floor") || "floors-10-23";
		const defaultFloor =
			floors.find(
				(floor) =>
					floor.getAttribute("data-floor-group") === defaultFloorKey,
			) ||
			floors[0];

		setActiveFloor(defaultFloor);
	});
}

floorPlanInteractiveExperience();
